import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationCancel, NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs/internal/Subscription';
import {DrawerComponent} from '../../../kt/components';
import {SessionQuery} from "../../../../shared/services/session/session.query";

export interface Alert {
  message: string,
  severity: string,
  title: string,
}
@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];

  closed: number[] = [];

  constructor(
    public sessionQuery: SessionQuery,
    private router: Router) {
  }

  ngOnInit(): void {
    this.routingChanges();
  }

  routingChanges() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // DrawerComponent.hideAll();
      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  close(id: number) {
    this.closed.push(id)
  }

  isClosed(id: number) {
    return this.closed.includes(id);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
